import {
    type FragmentType,
    getFragmentData,
    graphql
} from '~/resources/graphql'
import { computed, inject, provide } from 'vue'
import type { InjectionKey, Ref } from 'vue'

export const UseOrganizationContextFragment = graphql(`
    fragment UseOrganizationContextFragment on Organization {
        topBarLink
        topBarText(language: $language)
        topBarColor
        contactUsLinkText(language: $language)
        mobileUrl
        facilityPublicUrls
    }
`)

type OrganizationContextFragment = FragmentType<
    typeof UseOrganizationContextFragment
>

const organizationContextInjectionKey: InjectionKey<
    Ref<OrganizationContextFragment | null>
> = Symbol('organizationContextInjectionKey')

export function provideOrganizationContextFragment(
    organization: Ref<OrganizationContextFragment | null>
) {
    provide(organizationContextInjectionKey, organization)
}

export function useOrganizationContext() {
    const organization = inject(organizationContextInjectionKey)

    return computed(() => {
        if (organization === undefined || organization.value === null) {
            throw new Error('No Organization Context')
        }

        // Storefront chrome is fetched once through the app organization context
        // so facility/viewer fragments do not need their own language variable.
        return getFragmentData(
            UseOrganizationContextFragment,
            organization.value
        )
    })
}
